export default __webpack_public_path__ + "static/media/song.768fdcf5.jpg";